import {Point} from 'leaflet';

export function isPlanCalibrated(bimPlan): boolean {
  // A helper function to check if all coordinates in a point are non-default
  const isPointCalibrated = (point: Point) => {
    if (!point) {
      return false;
    }
    return Object.values(point)?.every(value => value !== 0 && value != null);
  };

  // Destructure the points from the bimPlan
  const {plan1Point1, plan1Point2, plan2Point1, plan2Point2} = bimPlan?.transform || {};

  // Check each point for calibration
  const res = isPointCalibrated(plan1Point1)
    && isPointCalibrated(plan1Point2)
    && isPointCalibrated(plan2Point1)
    && isPointCalibrated(plan2Point2);

  return res;
}
